import { render, staticRenderFns } from "./GGCardText.vue?vue&type=template&id=cb929540&"
import script from "./GGCardText.vue?vue&type=script&lang=js&"
export * from "./GGCardText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cb929540')) {
      api.createRecord('cb929540', component.options)
    } else {
      api.reload('cb929540', component.options)
    }
    module.hot.accept("./GGCardText.vue?vue&type=template&id=cb929540&", function () {
      api.rerender('cb929540', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Global/Card/GGCardText.vue"
export default component.exports